import { GoogleMap, InfoWindow, InfoWindowF, Marker, PolylineF, useJsApiLoader } from "@react-google-maps/api";
import VeiculoViagemDestino from "model/gestao/frotas/VeiculoViagemDestino";
import VeiculoViagemPontoPercurso from "model/gestao/frotas/VeiculoViagemPontoPercurso";
import React, { useEffect, useState } from "react";
import { OutputFormat, setDefaults } from "react-geocode";
import { converterDataHora } from "utils/convert";

type Props = {
    pontosPercurso: VeiculoViagemPontoPercurso[];
    destinos: VeiculoViagemDestino[];
    finalizada: boolean;
}
let polylineRef: google.maps.Polyline | null = null;
export default function MapaPercursoVeiculoViagem(props: Props) {
    const keyMaps = 'AIzaSyDQbLYImEY_K1U92ocx6-e46qC2AjskIfo';
    const [localizacaoInicio, setLocalizacaoInicio] = useState<{ lat: number, lng: number } | null>(null);
    const [localizacaoFim, setLocalizacaoFim] = useState<{ lat: number, lng: number } | null>(null);
    const [center, setCenter] = useState({ lat: -28.6782, lng: -49.370176 });
    const [hover, setHover] = useState<boolean[]>([]);

    const [destinos, setDestinos] = useState<VeiculoViagemDestino[]>([]);


    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: keyMaps,
    })

    const [map, setMap] = useState<google.maps.Map | null>(null)

    useEffect(() => {
        setDefaults({
            key: keyMaps,
            language: "pt",
            region: "br",
            outputFormat: OutputFormat.JSON
        });
    }, [])

    useEffect(() => {
        if (isLoaded) {
            polylineRef?.setMap(null);
            if (props.pontosPercurso.length > 0) {
                const inicio = props.pontosPercurso[0];
                const fim = props.pontosPercurso[props.pontosPercurso.length - 1];
                setLocalizacaoInicio({
                    lat: inicio.latitude,
                    lng: inicio.longitude
                });
                setLocalizacaoFim({
                    lat: fim.latitude,
                    lng: fim.longitude
                });
                setCenter({
                    lat: (inicio.latitude + fim.latitude) / 2,
                    lng: (inicio.longitude + fim.longitude) / 2
                });
            } else {
                setLocalizacaoInicio(null);
            }
            setDestinos(props.destinos);

        }
    }, [isLoaded]);

    const blueMarker = window.google ? {
        path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z",
        fillColor: "#4285F4",
        fillOpacity: 1,
        strokeColor: "#FFFFFF",
        strokeWeight: 1.5,
        scale: 2,
        anchor: new window.google.maps.Point(12, 22),
        labelOrigin: new window.google.maps.Point(12, 9),
    } : undefined;

    const blueMarkerWithCircle = {
        ...blueMarker,
        path:
            "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z M12 12a3 3 0 1 1 0-6a3 3 0 0 1 0 6z",
    };

    return (
        <div>
            {isLoaded ? <GoogleMap
                key={JSON.stringify(props.destinos.map(p => p.id))}
                onLoad={(map) => {
                    const bounds = new window.google.maps.LatLngBounds()
                    if (props.pontosPercurso.length === 0 && props.destinos.length > 0) {
                        props.destinos.forEach(ponto => {
                            bounds.extend({
                                lat: ponto.latitude,
                                lng: ponto.longitude
                            });
                        });
                    } else {
                        props.pontosPercurso.forEach(ponto => {
                            bounds.extend({
                                lat: ponto.latitude,
                                lng: ponto.longitude
                            });
                        });
                    }
                    map.fitBounds(bounds)
                    var listener = google.maps.event.addListener(map, "idle", function () {
                        if ((map.getZoom() || 0) > 15) map.setZoom(15);
                        google.maps.event.removeListener(listener);
                    })
                    setMap(map);
                }}
                zoom={15}
                center={center}
                onUnmount={() => { }}
                mapContainerStyle={{
                    height: "400px",
                    width: "824px"
                }}
            >

                {localizacaoInicio ? <>

                    <Marker position={localizacaoInicio} />
                    <InfoWindowF
                        position={localizacaoInicio}
                        options={{
                            disableAutoPan: true,
                            pixelOffset: new window.google.maps.Size(0, -40),
                        }}
                    >
                        <div style={styles.card}>Início</div>
                    </InfoWindowF>
                </> : null}
                {props.pontosPercurso.length > 0 ? <PolylineF
                    onLoad={(polyline) => {
                        polylineRef = polyline;
                    }}
                    path={props.pontosPercurso.map(ponto => ({ lat: ponto.latitude, lng: ponto.longitude })) || []}
                    key={props.pontosPercurso.length}
                    visible={props.pontosPercurso.length > 0}
                    options={{
                        strokeColor: "#240E92",
                        strokeOpacity: 0.5,
                        strokeWeight: 5,
                        geodesic: true,
                        clickable: false,
                        zIndex: 1
                    }}
                /> : null}
                {localizacaoFim ? <>
                    <Marker position={localizacaoFim} />
                    <InfoWindowF
                        position={localizacaoFim}
                        options={{
                            disableAutoPan: true,
                            pixelOffset: new window.google.maps.Size(0, -40),
                        }}
                    >
                        <div style={styles.card}>{props.finalizada ? "Fim" : "Localização atual"}</div>
                    </InfoWindowF>
                </> : null}
                {destinos.map((item, index) => {
                    const position = { lat: item.latitude, lng: item.longitude };
                    return <>
                        <Marker
                            position={position}
                            icon={blueMarkerWithCircle}
                            onMouseOver={() => {
                                const newHover = [...hover];
                                newHover[index] = true;
                                setHover(newHover);
                            }}
                            onMouseOut={() => {
                                const newHover = [...hover];
                                newHover[index] = false;
                                setHover(newHover);
                            }}
                        />

                        {
                            hover[index] && (
                                <InfoWindowF
                                    position={position}
                                    options={{
                                        disableAutoPan: true,
                                        pixelOffset: new window.google.maps.Size(0, -40),
                                        zIndex: 9999
                                    }}
                                >
                                    <div style={styles.card}>
                                        <div style={{ fontWeight: "bold", marginBottom: 4 }}>Horário: {converterDataHora(item.dataHora)}</div>
                                        <div style={{ fontWeight: "normal", width: "150px" }}>
                                            {item.observacao}
                                        </div>
                                    </div>
                                </InfoWindowF>
                            )
                        }
                    </>
                })}

            </GoogleMap> : null}
        </div>
    )
}

const styles: { [key: string]: React.CSSProperties } = {
    card: {
        fontSize: "12px",
        fontWeight: "bold",
    },
};